'use client'

import { Cell } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { Notification } from '@marketplace-web/common-components/notification-ui'

type Props = { handleClose: () => void }

const ItemUploadFeedbackNotification = ({ handleClose }: Props) => {
  const translate = useTranslate('item_upload.feedback')

  return (
    <Notification
      testId="item-upload--feedback-notification"
      onClose={handleClose}
      body={
        <div className="item-upload__feedback-notification">
          <Cell
            theme="transparent"
            styling="tight"
            title={translate('finalized.title')}
            body={translate('finalized.body')}
          />
        </div>
      }
      suffix={<div />}
    />
  )
}

export default ItemUploadFeedbackNotification
